import request from "@/router/axios";

// 代理商返佣
export const normalFlowableRebatePage = (current, size,params, search) => {
  return request({
    url: `/api/blade-businessNormalFlowable/businessNormalFlowable/normal-flowable-web-rebate-page`,
    method: "post",
    data: {
      current,
      size,
      ...params,
      ...search,
    },
  });
};

// 详情
export const normalFlowableDetail = (loanPaymentRecordId) => {
  return request({
    url: `/api/blade-businessNormalFlowable/businessNormalFlowable/normal-flowable-detail`,
    method: "get",
    data: {
      id,
    },
  });
};

//  提交
export const normalFlowableAudit = (data) => {
  return request({
    url: `/api/blade-businessNormalFlowable/businessNormalFlowable/normal-flowable-audit`,
    method: "post",
    data: data
  });
};

